export { default } from './RelativeLinkForCurrentUser'
